<template>
  <div>

    <v-list two-line class="pa-0" color="transparent">
      <v-list-item v-for="serv in services" :key="serv.id" @click.native.stop="checkService(serv)">
        <v-list-item-content class="d-block">
          {{serv.name}}
          <v-list-item-subtitle>
            л/c: {{serv.account}} &#8226; ФИО: {{serv.fio}}
          </v-list-item-subtitle>
        </v-list-item-content>


        <v-list-item-action>
          <v-switch v-if="serv.canWire" v-model="selectedServices" :value="serv.id" :disabled="!serv.canWire"
            color="primary" hide-details :ripple="!isLegacyAndroid" :class="[{'android-legacy-switch-fix': isLegacyAndroid}]"  />
          <v-icon v-else>block</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-slide-y-reverse-transition>
      <v-footer class="pa-0" v-if="services && services.length > 0" height="64" app
        :color="$vuetify.theme.dark ? 'black' : 'white'">
        <div style="width: 100%">
          <div class="pb-3 px-3">
            <v-btn class="sg-wire-services-btn" block color="primary" x-large @click="wireServices"
              :disabled="!wireEnabled">Подключить
            </v-btn>
          </div>
        </div>
      </v-footer>
    </v-slide-y-reverse-transition>

  </div>
</template>

<script>
  export default {
    props: {
      services: {
        type: Array,
        required: true
      }
    },
    watch: {
      services() {
        if (this.services) {
          this.selectedServices = this.services.filter(s => s.canWire && s.defaultWire).map(s => s.id)
        }
      },
    },
    computed: {
      wireEnabled() {
        return this.selectedServices && this.selectedServices.length > 0
      }
    },
    data() {
      return {
        selectedServices: []
      }
    },
    methods: {
      checkService(service) {
        if (!service.canWire) {


          this.$eventBus.$emit('modal:dialog', {
            props: {
              message: service.error,
              acceptText: 'Ок',
            },
            dialogProps: {
              noClickAnimation: true,
              persistent: true,
            }
          })
        }
      },
      wireServices() {
        if (!this.selectedServices || this.selectedServices.length == 0) return
        this.$emit('wire', this.selectedServices)
      }
    }
  }
</script>

<style>

</style>